<template>
    <div>
        <el-collapse>
            <el-collapse-item title="베팅통계 보기" name="1">
                <table class="table100" style="border-bottom: 1px solid #00ffff">
                    <tr align="center">
                        <th>게임</th>
                        <th>베팅건수</th>
                        <th>당첨건수</th>
                        <th>당첨확율</th>
                        <th>베팅금액</th>
                        <th>당첨금액</th>
                        <th>손익금</th>
                    </tr>
                    <tr v-for="item in leisureGameBetInfoStatistic">
                        <th>{{item.tattrName}}</th>
                        <td>{{item.tcount}}&nbsp;건</td>
                        <td>{{item.winCount}}&nbsp;건</td>
                        <td>
                            <span :class="{'text-danger':item.winningProbability >= 50}">{{item.winningProbability}}%</span>
                        </td>
                        <td>{{item.tamount|comma}}&nbsp;원</td>
                        <td>{{item.twinAmount|comma}}&nbsp;원</td>
                        <td>
                            <span :class="{'text-danger':item.tamount - item.twinAmount < 0}" ng-if="">{{(item.tamount - item.twinAmount)|comma}}&nbsp;원</span>

                        </td>
                    </tr>
                </table>
            </el-collapse-item>
        </el-collapse>
        <div class="search">
            <div class="date_selector">
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker size="mini"
                                    style="width: 130px"
                                    v-model="startDate"
                                    align="right"
                                    type="date"
                                    placeholder="시작일"
                                    :picker-options="pickerOptions"
                                    @change="setStartDate">
                    </el-date-picker>
                </div>
                <div style="padding-left: 1px;padding-right: 1px;color: #cfcfd1">~</div>
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker size="mini"
                                    style="width: 130px"
                                    v-model="endDate"
                                    align="right"
                                    type="date"
                                    placeholder="마감일"
                                    :picker-options="pickerOptions"
                                    @change="setEndDate">
                    </el-date-picker>
                </div>
            </div>
            <el-button type="primary" size="mini" style="margin-left: 5px" @click="search">검색
            </el-button>
            <el-select v-model="leisureGameBet.betResult" @change="getleisureGameBetList" size="mini" placeholder="결과선택"
                       style="width:100px;margin-left: 5px">
                <el-option key="13" label="전체" :value="null">전체</el-option>
                <el-option key="14" label="대기" :value="managerConst.SportsBet.BET_RESULT_WAITING">대기</el-option>
                <el-option key="15" label="당첨" :value="managerConst.SportsBet.BET_RESULT_WIN">당첨</el-option>
                <el-option key="16" label="낙첨" :value="managerConst.SportsBet.BET_RESULT_LOSE">낙첨</el-option>
                <el-option key="17" label="취소" :value="managerConst.SportsBet.BET_RESULT_CANCEL">취소</el-option>
                <el-option key="18" label="적특" :value="managerConst.SportsBet.BET_RESULT_SPECIALCASE">적특
                </el-option>
            </el-select>
        </div>
        <div style="padding: 5px 0;font-size: 14px">
            <span :class="{'text-danger':totalWinnerCash < 0,'text-blue':totalWinnerCash>0}">수익금:{{totalWinnerCash|comma}} 원 </span>
            <span style="padding-left: 20px;">총건수:{{totalBetCount|comma}}건</span>
            <span style="padding-left: 20px;">
                        총베팅금액:{{totalBetCash|comma}}원
                    </span>
            <span style="padding-left: 20px;">
                        베팅진행중금액: {{totalBetingCash|comma}} 원
                    </span>
            <span style="padding-left: 20px;">당첨금액:{{totalBetWinCash|comma}} 원 </span>
            <span style="padding-left: 20px;">낙첨금액:{{totalBetLoseCash|comma}} 원</span>
            <span style="padding-left: 20px;">적특:{{totalSpecial|comma}} 원 </span>
            <span style="padding-left: 20px;">취소:{{totalCancel|comma}} 원</span>
        </div>
        <leisure-game-bet-comp :key="200" :list="leisureGameBetList"
                               @leisureRefresh="leisureRefresh"></leisure-game-bet-comp>
        <div class="pagePanel">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[10,50, 100, 150, 200]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
            </el-pagination>
        </div>

    </div>

</template>

<script>
    import managerConst from "../../common/administrator/managerConst";

    import DateSelectorComp from "./DateSelectorComp";
    import SportsBetInfoComp from "./SportsBetInfoComp";
    import {getLeisureGameBetStatisticByAttribute, getLeisureGameList} from "../../network/manager/leisureBetRequest";


    export default {
        name: "UserInfoLeisureGameBetComp",
        components: {SportsBetInfoComp, DateSelectorComp, LeisureGameBetComp: () => import('./LeisureGameBetComp.vue')},
        data() {
            return {
                startDate: '',
                endDate: '',
                leisureGameBet: {partnerId: null, user: {}},
                leisureGameBetList: [],
                leisureGameBetInfoStatistic: {},
                leisureGameBetInfoStatisticLatelySearch: {},
                pageNum: 1,
                pageSize: 10,
                orderBy: 'id DESC',
                orderByText: '시간순',
                pageTotal: 0,

                totalBetCount: 0,
                totalBetCash: 0,
                totalBetingCash: 0,
                totalBetWinCash: 0,
                totalBetLoseCash: 0,
                totalWinnerCash: 0,
                totalSpecial: 0,
                totalCancel: 0,
                managerConst: managerConst,
                pickerOptions: {
                    shortcuts: [{
                        text: '오늘',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '어제',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '일주일전',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '15일전',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 14);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '30일전',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '60일전',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 60);
                            picker.$emit('pick', date);
                        }
                    }]
                },
            }
        },
        props: {
            uid: {
                type: Number,
                default() {
                    return 0;
                }
            },

        },
        methods: {
            search() {
                this.getleisureGameBetList()
                this.getLeisureGameBetStatistic();
            },
            getleisureGameBetList() {
                this.leisureGameBet.startDate = this.startDate
                this.leisureGameBet.endDate = this.endDate
                getLeisureGameList(this.leisureGameBet, this.pageNum, this.pageSize, this.orderBy).then(res => {
                    this.pageTotal = res.data.total;
                    this.leisureGameBetList = res.data.data.betList;
                    this.totalBetCount = res.data.total;
                    this.totalBetCash = res.data.data.cashInfo.totalBetCash;
                    this.totalBetingCash = res.data.data.cashInfo.totalBetingCash;
                    this.totalBetWinCash = res.data.data.cashInfo.totalBetWinCash;
                    this.totalBetLoseCash = res.data.data.cashInfo.totalBetLoseCash;
                    this.totalWinnerCash = res.data.data.cashInfo.totalWinnerCash;
                    this.totalSpecial = res.data.data.cashInfo.totalSpecial;
                    this.totalCancel = res.data.data.cashInfo.totalCancel;
                })

            },
            getLeisureGameBetStatistic() {
                this.leisureGameBetInfoStatisticLatelySearch.startDate = this.startDate;
                this.leisureGameBetInfoStatisticLatelySearch.endDate = this.endDate;
                getLeisureGameBetStatisticByAttribute(this.leisureGameBetInfoStatisticLatelySearch).then(res => {
                    this.leisureGameBetInfoStatistic = res.data.data;
                });
            },
            handleSizeChange(val) {
                this.pageNum = 1;
                this.pageSize = val;
                this.getleisureGameBetList();
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getleisureGameBetList();
            },
            setStartDate(date) {
                this.startDate = this.$moment(date).format('yyyy-MM-DD');
            },
            setEndDate(date) {
                this.endDate = this.$moment(date).format('yyyy-MM-DD')
            },
            setPartnerId(parterId) {
                this.leisureGameBet.partnerId = parterId
                this.search();
            },
            leisureRefresh() {
                this.search();
            }
        },
        created() {

        },
        watch: {
            uid: {
                handler(newVal) {
                    if (newVal != null && newVal != 0) {
                        this.startDate = this.$moment().subtract(1, 'days').format('yyyy-MM-DD')
                        this.endDate = this.$moment().format('yyyy-MM-DD')
                        this.leisureGameBet.userId = this.uid
                        this.leisureGameBetInfoStatisticLatelySearch.userId = this.uid
                        this.search()
                    }

                },
                immediate: true,
                deep: false
            },
        }
    }
</script>

<style scoped>

</style>